<template lang="pug">
.shop-banner.mb-1.bg-dark.text-center
  img(v-if=" typeof specialOffer.shopImage != 'undefined' && specialOffer.shopImage.mimeType != 'video/mp4'" :src="'/imgw'+specialOffer.shopImage.url")
  video(v-if="typeof specialOffer.shopImage != 'undefined' && specialOffer.shopImage.mimeType == 'video/mp4'" autoplay style="width:100%" muted onloadeddata="this.play();" :loop="specialOffer.shopImage.name.includes('loop')")
    source(type="video/mp4" :src="imageHost+'/imgw'+specialOffer.shopImage.url")
  div.text-white.bg-dark.px-3.py-2
    div.float-left.py-2
      strong {{ specialOffer.description }}
    template(v-if="!noCartButtons")
      div.float-right.py-2.pl-2(v-if="!buttonMode") (Max. {{specialOffer.maxQuantityPerCustomer}} )
      button.btn.btn-primary.btn-md.float-right.text-white(
          v-if="buttonMode"
          @click="addOrRemoveSpecialOffer()"
          type="button"
          :disabled="!orderable"
          ) {{ buttonText }}
      input.form-control.float-right(
        style="width: 35px;"
        v-else
        type="text"
        inputmode="numeric" pattern="[0-9]*"
        min="0" step="1" :max="this.specialOffer.maxQuantityPerCustomer"
        v-model.number="productQuantities[specialOffer.id]")
      div.float-right.py-2.pr-2(v-if="typeof specialOffer.product.priceB2b === 'number'") {{ specialOffer.product.priceB2b.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}
    div(style="clear: both;")
    div.text-white.text-left.bg-dark.offer-info-box(v-if="this.specialOffer.infoBox" v-html="this.specialOffer.infoBox")
</template>

<script>
export default {
  name: 'SpecialOffer',
  props: {
    remainingProductQuantities: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    productQuantities: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    specialOffer: {
      type: Object,
      required: true,
      default: () => {}
    },
    noCartButtons: {
      type: Boolean,
      required: true,
      default: () => false
    }
  },
  data: () => ({
    imageHost: process.env.VUE_APP_IMG_HOST
  }),
  computed: {
    orderable () {
      return this.remainingProductQuantities[this.specialOffer.id] > 0
    },
    buttonMode () {
      return this.specialOffer.maxQuantityPerCustomer === 1
    },
    inCart () {
      return this.productQuantities[this.specialOffer.id] > 0
    },
    buttonText () {
      if (this.remainingProductQuantities[this.specialOffer.id] === 0) {
        return 'Ausverkauft'
      }
      return this.inCart ? 'Entfernen' : 'In den Warenkorb'
    }
  },
  watch: {
    productQuantities: {
      handler () {
        if (this.productQuantities[this.specialOffer.id] > this.specialOffer.maxQuantityPerCustomer) {
          const newQuantities = { ...this.productQuantities }
          newQuantities[this.specialOffer.id] = this.specialOffer.maxQuantityPerCustomer
          this.$emit('update-quantities', newQuantities)
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    addOrRemoveSpecialOffer () {
      const newQuantities = { ...this.productQuantities }
      if (this.inCart) {
        console.info('remove', this.specialOffer.id)
        newQuantities[this.specialOffer.id] = 0
      } else {
        if (this.remainingProductQuantities[this.specialOffer.id] === 0) {
          return
        }
        console.info('add', this.specialOffer.id)
        newQuantities[this.specialOffer.id] = 1
      }
      this.$emit('update-quantities', newQuantities)
    }
  }
}
</script>
<style lang="stylus">
.shop-banner
    img
      max-width 100%
</style>
